export default "__VITE_ASSET__Dm_QUAIo__"